export default [
    {
        fileName: "cross sell 1.jpg",
        isCorporate: true,
        link:
            "https://upmoldova.md/tichete-cadou/",
        label: "Up Cadou",
    },
    {
        fileName: "cross sell 2.jpg",
        isCorporate: true,
        link:
            "https://upmoldova.md/tichete-de-masa/",
        label: "Up Dejun",
    },
    {
        fileName: "cross sell 3.jpg",
        isCorporate: false,
        link:
            "https://sign.upmoldova.md/",
        label: "Up Family",
    },
];
